import React, { useEffect, useState } from 'react'
import styles from './AddNewTask.module.scss'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import { dateFormat } from 'helpers/date'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import DatePicker from 'react-datepicker'
import { timeConverter } from 'components/ContentBox//Online-schedule/components/functions'
import { addZero } from 'helpers/math'
import SearchInput from 'components/ContentBox/Global/SearchInput/SearchInput'
import useLocalization from 'hooks/useLocalization'
import { dict, translate as loc } from 'Localisation'
import { localisationMaster } from 'Localisation/Localisation'

const AddNewTask = ({ addTaskFromDeal }) => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const [executors, setExecutors] = useState([])
  const [taskCategory, setTaskCategory] = useState([])
  const [isDisabled, setIsDisabled] = useState(true)

  const { translate } = useLocalization({
    section: 'Crm_tasks',
    subsection: 'task',
    dict: {
      transaction_buyer: 'Contact, transaction buyer',
      task_type: 'Task type',
      name: 'Name',
      executor: 'Executor',
      start_finish_time: 'Start & Finish Time',
      start_date: 'Start Date',
      end_date: 'End Date',
      modal_title_add_task: 'Add a new task',
      start: 'Start',
      end: 'End',
      period: 'Period',
      date: 'Date',
    },
  })

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/employees',
      params: {
        limit: 999,
        short_form: true,
      },
      crm: true,
    })
      .then(({ data }) => {
        setExecutors(data)

        const hasSelected = asideModalStore.modalValues?.assignee
        if (!hasSelected && addTaskFromDeal) {
          const managerId = asideModalStore.modalValues?.manager
          if (managerId && data.some((emp) => emp.id === managerId)) {
            changeValues(managerId, 'assignee')
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsDisabled(false)
      })
  }, [])

  useEffect(() => {
    superAxiosRequest({
      method: 'get',
      link: 'tasktracker/task_categories',
      params: {},
      crm: true,
    })
      .then(({ data }) => {
        const categories = data?.result || []
        setTaskCategory(categories)

        const hasSelected = asideModalStore.modalValues?.task_category
        if (!hasSelected) {
          const defaultCategory = categories.find(
            (cat) => cat.id === 52 || cat.name === 'Contact',
          )
          if (defaultCategory) {
            changeValues(defaultCategory.id, 'task_category')
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsDisabled(false)
      })
  }, [])

  const getStudentList = (value) => {
    const deal = value[0]
    changeValues(deal.id, 'deal')
  }

  const handleDateChange = (val) => {
    const formattedDate = dateFormat(val, 'YYYY-mm-dd')
    changeValues(formattedDate, 'date')
  }

  return (
    <div className={styles.groupForm}>
      {!addTaskFromDeal && (
        <FormField>
          <FormLabel isRequired>{translate.transaction_buyer}:</FormLabel>
          <SearchInput
            link='integration/deals'
            placeholder={translate.name}
            new_key='deal_name'
            backFunction={getStudentList}
            crm={true}
            error={check('deal')}
          />
        </FormField>
      )}

      <FormField>
        <FormLabel isRequired>{translate.executor}:</FormLabel>
        <SelectCustom
          placeholder={translate.executor}
          options={executors}
          sortKey='name'
          valueID={modalValue?.assignee}
          onChange={(o) => changeValues(o.id, 'assignee')}
          isSearchable
          isDisabled={isDisabled}
          error={check('assignee')}
        />
      </FormField>

      <div className={styles.fieldSet}>
        <FormField>
          <FormLabel>{translate.start_finish_time}:</FormLabel>
          <FormInput>
            <div className={styles.datetimeBox}>
              <DatePicker
                selected={
                  modalValue.start_at
                    ? new Date('2020-01-01T' + modalValue.start_at)
                    : new Date('2020-01-01T06:00:00')
                }
                onChange={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'start_at',
                  )
                }}
                onSelect={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'start_at',
                  )
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={translate.start}
                timeFormat='HH:mm'
                dateFormat='HH:mm'
              />
              <div className={styles.datetimeBoxMiddle}>-</div>
              <DatePicker
                selected={
                  modalValue.finish_at
                    ? new Date('2020-01-01T' + modalValue.finish_at)
                    : new Date('2020-01-01T23:00:00')
                }
                onChange={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'finish_at',
                  )
                }}
                onSelect={(date) => {
                  changeValues(
                    timeConverter(date, 'time') +
                      `:${addZero(date.getSeconds())}`,
                    'finish_at',
                  )
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption={translate.end}
                timeFormat='HH:mm'
                dateFormat='HH:mm'
              />
            </div>
          </FormInput>
        </FormField>

        <div className={styles.datePicker}>
          <FormLabel isRequired>{translate?.date}:</FormLabel>
          <div className={styles.dateSelector}>
            <FormDateSelector
              placeholder={translate.date}
              onChange={handleDateChange}
              value={modalValue?.date || ''}
              error={check('date')}
            />
          </div>
        </div>
      </div>

      <FormField>
        <FormLabel isRequired>{translate.task_type}:</FormLabel>
        <SelectCustom
          placeholder={translate.task_type}
          options={taskCategory}
          sortKey='name'
          isDisabled={isDisabled}
          isSearchable
          valueID={modalValue?.task_category}
          onChange={(o) => changeValues(o.id, 'task_category')}
          error={check('task_category')}
        />
      </FormField>

      <FormField>
        <FormLabel>{loc(dict.main_page.comment)}:</FormLabel>
        <FormInput>
          <textarea
            onChange={(e) => changeValues(e.target.value, 'comment')}
            value={modalValue.comment}
            placeholder={localisationMaster(
              'comment',
              'online-schedule/future-slots',
            )}
          />
        </FormInput>
      </FormField>

      {addTaskFromDeal && (
        <FormField>
          <FormLabel>Выбор статуса задачи:</FormLabel>
          <SelectCustom
            placeholder={translate.task_type}
            apiLinkCRM='tasktracker/task_statuses'
            optionValueKey='id'
            optionLabelKey='name'
            valueID={modalValue?.status}
            onChange={(status) => changeValues(status.id, 'status')}
            error={check('status')}
          />
        </FormField>
      )}
    </div>
  )
}

export default observer(AddNewTask)
